import { render } from "./JoinNowMemberStep02Location.vue?vue&type=template&id=07060848&scoped=true"
import script from "./JoinNowMemberStep02Location.vue?vue&type=script&lang=js"
export * from "./JoinNowMemberStep02Location.vue?vue&type=script&lang=js"

import "./JoinNowMemberStep02Location.vue?vue&type=style&index=0&id=07060848&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07060848"]])

export default __exports__